export default {
	consumption: {
		consumptionInformation: 'Consumption information',
		heating: 'Heating',
		hot_water: 'Hot water',
		name: 'Consumption',
		kwh: 'kWh',
		estimated_costs: 'Estimated costs',
		emissions: 'Emissions',
		efficiency: 'Efficiency',
		consumption_per_sqm: 'Consumption per sqm',
		limit_value: 'Limit value',
		monthly: 'Monthly',
		yearly: 'Yearly',
		consumption_kwh: 'Consumption in kWh',
		emissions_grams_co2: 'Emissions in grams CO2',
		costs_euro: 'Costs in Euro',
	},
}
